var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterPolo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M9.702 11.806c-.5.83-2.642 1.306-1.923.289.605-1.154.89-2.421-.022-4.246-.268-.508-.183-.861.135-1.287.523-.693.836-.939 1.346-.262 1.376 1.77 1.422 4.038.464 5.506z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M10.712 11.34c-.54.507-.469.116-.382-.215.412-1.768.354-3.496-1.06-5.176-.289-.3-.105-.545.55-.734.47-.172.799-.137.985.107 1.787 3.083 1.394 4.891-.093 6.018z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#509CF2",
    d: "M7.5 13.727h.321c3.44-.013 6.179-.235 6.179-.507s-2.647-.349-6.082-.353h-.642C3.83 12.87 1 12.947 1 13.22c0 .28 2.91.507 6.5.507z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFDF1B",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFDF1B",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDF1B",
    d: "M12.495 8.019c-.013.435-.242.713-.297.158-.12-.915-.565-1.841-1.028-2.775-.13-.222-.044-.347.258-.374.304-.028.517.061.638.268.475.83.466 1.756.43 2.723zm-8.133 3.347c.966.327 1.946.588 3.007.455.317-.004-.013.503-.241.624-.497.327-2.06-.267-2.532-.624-.497-.307-.702-.647-.234-.455z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDF1B",
    d: "M2.63 8.085C4.168 9.878 5.875 10.195 7.643 10c.764-.155.426 1.565-.247 1.572-2.99.036-4.806-.98-5.192-3.188-.09-.619.099-.718.428-.298z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDF1B",
    d: "M3.041 5.446c.803 1.253 1.87 2.217 3.644 2.23.48-.026.857.301 1.13.981.467 1.117-.31 1.074-.706 1.093-2.498.063-3.73-.952-4.581-2.253-.567-.818.003-2.98.513-2.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDF1B",
    d: "M3.638 5.108c-.316.521-.793-.337-.502-.742.568-.806 1.384-1.43 2.475-1.85.563-.206 1.034-.158.314.237-1.045.571-1.668 1.394-2.287 2.355zm3.823 1.61c-.388.708-1.116.7-1.728.573-.408-.078-.687-.32-.325-1.032.703-1.368 1.873-2.794 4-2.956 1.093-.107 1.58.345 1.997.9.482.756-.11.548-.985.654-1.398.205-2.344.891-2.959 1.86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDF1B",
    d: "M5.045 6.354c-.257.57-.61.378-.991-.026-.382-.404-.324-.698-.221-.949.575-1.237 1.655-2.317 3.199-2.761.013-.005 1.1-.324 1.816-.132.194.053.34.099.436.136.08.03.201.087.363.17.405.2.068.225-.137.236-1.98.075-3.435 1.253-4.465 3.326z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#509CF2",
    d: "M13.089 10.914a.74.74 0 0 0 .749-.732c0-.405-.627-.694-1.13-.507-.503.187-1.13 1.505-1.13 1.91.415-.885 1.097-.67 1.51-.67zM1.99 3.288a.51.51 0 0 1-.514-.503c0-.278.43-.477.777-.349.346.129.777 1.035.777 1.313-.286-.608-.755-.46-1.04-.46zm.42-1.308a.417.417 0 0 1-.226-.544c.089-.21.477-.221.696-.014.22.207.255 1.028.166 1.237-.02-.55-.421-.588-.635-.68z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterPolo);
export default __webpack_public_path__ + "static/media/water_polo.d2716d469dc51577b6d1d1dc4c218843.svg";
export { ForwardRef as ReactComponent };